// Promise wrapper
const FBPromise = {
  login: () =>
    new Promise((resolve) => {
      window.FB.login(
        (response) => {
          resolve(response)
        },
        { scope: 'public_profile,email' },
      )
    }),
  me: () =>
    new Promise((resolve) => {
      window.FB.api(
        '/me',
        'GET',
        {
          fields: 'email,name,id,first_name,last_name,picture',
        },
        resolve,
      )
    }),
}

// Public functions
const load = ({ appId }) => {
  if (document.getElementById('facebook-jssdk')) {
    return
  }

  const js = document.createElement('script')

  js.src = '//connect.facebook.net/en_US/sdk.js'
  js.id = 'facebook-jssdk'

  window.fbAsyncInit = () => {
    window.FB.init({
      appId,
      xfbml: true,
      version: 'v4.0',
    })
  }

  document.body.appendChild(js)
}

const login = async () => {
  const response = await FBPromise.login()

  if (!response.authResponse) {
    throw new Error('Facebook: No auth response')
  }

  if (response.status !== 'connected') {
    throw new Error('Facebook: Not connected')
  }

  const authResponse = response.authResponse
  const userResponse = await FBPromise.me()

  return {
    ...authResponse,
    ...userResponse,
  }
}

export default {
  load,
  login,
}
